module.exports = __webpack_public_path__ + "img/hohlsaum_gelb_candy.a599631a.jpg";